import { module } from 'modujs';
import formMixin from '../vue-mixins/formMixin';

const { required, email, minLength, sameAs } = window.validators;

const formProperties = {
    email: {
        required,
        email
    },
    password: {
        required,
        minLength: minLength(8)
    },
    remember: {},
    token: {},
    confirmPassword: {
        required,
        sameAsPassword: sameAs('password')
    }
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Initial values are used to prefill the form.
        const initialValues = this.getData('values')
        this.initialValues = initialValues ? JSON.parse(initialValues) : {}

        this.validProperties = undefined;
        this.propertiesValidation = undefined;

        // Define the available properties in the form
        this.assetValidProperties();
        // Init vue
        this.initVue()
    }

    /**
     * Asset existing properties in the given form
     */
    assetValidProperties() {
        this.validProperties = {
            submitStatus: "",
        };
        this.propertiesValidation = {};

        for (let ident in formProperties) {
            if (this.el.querySelector("[name=" + ident + "]")) {
                this.propertiesValidation[ident] = formProperties[ident];
                this.validProperties[ident] = "";
            }
        }
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this

        /////////////////////////
        // Settings
        Vue.config.devtools = true

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default)
        const { required, minLength, email } = window.validators

        /////////////////////////
        // Import captcha
        const captcha = JSON.parse(this.el.getAttribute('data-captcha'));

        /////////////////////////
        // Vue Instance
        this.app = new Vue({

            el: this.el,

            delimiters: ['${', '}'],

            mixins: [
                formMixin,
            ],

            data: () => {
                return {
                    captcha: captcha,
                    ...this.validProperties
                }
            },

            validations: this.propertiesValidation,

            created() {
                this.moduleInstance = moduleInstance
                // Init form mixin
                this.initForm !== undefined && this.initForm()

                // Set initial values
                this.moduleInstance.initialValues &&
                this.setInitialValues(this.moduleInstance.initialValues);
            },
            setInitialValues(values) {
                Object.assign(this, values);
            }
        })
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
